// src/encounter/inserted-templates/inserted-templates-panel.tsx
// The templates added from the "/" menu, one block each, in the order they were added. Drawn right after the note's own
// template sections. With no host, or no sets, it draws nothing.
import { Banner } from '@scripsteam/scrips-signal-ds';
import { useInsertedTemplatesContext } from './inserted-templates-context';
import { InsertedTemplateBlock } from './inserted-template-block';

export function InsertedTemplatesPanel({ role, className = '' }: { role: 'nurse' | 'physician'; className?: string }) {
  const inserted = useInsertedTemplatesContext();
  if (!inserted || (inserted.sets.length === 0 && !inserted.insertFailed)) return null;
  return (
    <div data-slot="inserted-templates" className={`flex flex-col gap-3 ${className}`.trim()}>
      {inserted.sets.map((set) => (
        <InsertedTemplateBlock key={set.answerSetId} set={set} role={role} onChange={inserted.change} onRetry={inserted.retry} onRemove={inserted.remove} />
      ))}
      {inserted.insertFailed && (
        <Banner variant="error" role="alert" title="Template not added" data-testid="inserted-template-insert-failed">
          The template could not be added. Try again.
        </Banner>
      )}
    </div>
  );
}
